import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ITextButton } from './text-button.component.interface';

@Component({
    selector: 'mlp-ng-text-button-internal-atom',
    templateUrl: './text-button-internal.component.html',
    styleUrls: ['./text-button-internal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class TextButtonInternalAtomSharedComponent implements AfterViewInit {
    @Input() attributes: ITextButton['attributes'];
    @Input() label: ITextButton['label'];
    @Input() url: ITextButton['url'];
    @Input() icon: ITextButton['icon'];
    @Input() uppercase: ITextButton['uppercase'] = true;
    @Input() color: ITextButton['color'];

    @ViewChild('aTag') aTagElement: ElementRef<HTMLElement>;

    ngAfterViewInit(): void {

        if (this.attributes) {
            Object.keys(this.attributes).forEach(key => {
                this.aTagElement.nativeElement.setAttribute(key, this.attributes[key]);
            });
        }
    }

}
